"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = getWindow;
exports.g = getDocument;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function isObject(e) {
  return null !== e && "object" == _typeof(e) && "constructor" in e && e.constructor === Object;
}
function extend(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function (n) {
    void 0 === e[n] ? e[n] = t[n] : isObject(t[n]) && isObject(e[n]) && Object.keys(t[n]).length > 0 && extend(e[n], t[n]);
  });
}
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ""
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  var e = "undefined" != typeof document ? document : {};
  return extend(e, ssrDocument), e;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return "";
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(e) {
    return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(e) {
    "undefined" != typeof setTimeout && clearTimeout(e);
  }
};
function getWindow() {
  var e = "undefined" != typeof window ? window : {};
  return extend(e, ssrWindow), e;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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